"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = getWindow;
exports.g = getDocument;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function isObject(e) {
  return null !== e && "object" == _typeof(e) && "constructor" in e && e.constructor === Object;
}
function extend(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function (n) {
    void 0 === e[n] ? e[n] = t[n] : isObject(t[n]) && isObject(e[n]) && Object.keys(t[n]).length > 0 && extend(e[n], t[n]);
  });
}
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ""
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  var e = "undefined" != typeof document ? document : {};
  return extend(e, ssrDocument), e;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return "";
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(e) {
    return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(e) {
    "undefined" != typeof setTimeout && clearTimeout(e);
  }
};
function getWindow() {
  var e = "undefined" != typeof window ? window : {};
  return extend(e, ssrWindow), e;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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